import axiosInstance, { ApiKeys, getApiUrl } from '@cp/utils/ApiHelper';
import { IPublishMetricPayload } from '@cp/constants/ameyoConstants';

export const publishMetric = (payload: IPublishMetricPayload) => {
  const url = getApiUrl(ApiKeys.PUBLISH_METRICS_TO_GRAPHANA);
  axiosInstance.post(url, payload, {
    headers: {
      includeInUptimeMetrics: true
    }
  });
};
